import { TableSearchQueryRowParams } from './table-search-query';

let currentRowId = 0;

export class TableSearchRow {
  rowId: string;
  query: TableSearchQueryRowParams;
  hasMerkmalChanged?: boolean;
  hasError: boolean;

  constructor() {
    this.rowId = (currentRowId++).toString();
    this.query = {
      relation: 'And',
      openingBrackets: 0,
      key: null,
      operator: null,
      closingBrackets: 0,
      value: null,
    };
  }
}
